package com.bikompanion.data.rating

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.data.cache.LocalStore
import com.bikompanion.data.cache.cacheKey
import com.bikompanion.domain.RatingPreferencesRepository
import com.bikompanion.domain.di.AppScope

private const val LastNetworkKey = "last_rating_network_id"

/** A bare id needs none of [PendingVoteQueue]'s JSON envelope — there's exactly one value. */
@ContributesBinding(AppScope::class)
@Inject
class RatingPreferencesRepositoryImpl(
    private val store: LocalStore,
) : RatingPreferencesRepository {
    override fun getLastNetworkId(): String? = store.read(cacheKey(LastNetworkKey))?.takeIf { it.isNotEmpty() }

    override fun setLastNetworkId(networkId: String) {
        store.write(cacheKey(LastNetworkKey), networkId)
    }
}
